import React from 'react';

export interface VirtualKeyboardContextProps {
  showKeyboard: boolean,
  setShowKeyboard: Function,
  selectedInput: HTMLInputElement,
  setSelectedInput: Function
}

const VirtualKeyboardContext = React.createContext<Partial<VirtualKeyboardContextProps>>({
  showKeyboard: false,
  setShowKeyboard: () => {},
  selectedInput: null,
  setSelectedInput: () => {}
});

export default VirtualKeyboardContext;
